export const ROUTE_PATHS = {
  WEBSITE: '/',
  WEBSITE_TERMS: '/terms',
  WEBSITE_PRIVACY: '/privacy',
  WEBSITE_SUPPORT: '/support',
  HOME: '/dashboard',
  LOGIN: '/login',
  REGISTER: '/register',
  BUSINESS_REGISTER: '/business/register',
  // Phase 4.4c-2 — onboarding wizard. /business/register stays as a
  // compatibility redirect (4.4c-3 → 4.4c-4 cleanup).
  ONBOARDING: '/onboarding',
  // Phase 4.4b-2 — auth-flow routes. Placeholder pages in 4.4b-2;
  // full screens in 4.4b-3.
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_OTP: '/reset-password-otp',
  VERIFY_EMAIL: '/verify-email',
  VERIFY_PHONE: '/verify-phone',
  INVENTORY: {
    ROOT: '/inventory',
    NEW_PRODUCT: '/inventory/products/new',
    PRODUCT_DETAIL: (productId: string) => `/inventory/products/${productId}`,
    ADD_VARIANT: (productId: string) => `/inventory/products/${productId}/variants/new`,
    EDIT_VARIANT: (productId: string, variantId: string) =>
      `/inventory/products/${productId}/variants/${variantId}/edit`,
    RECEIVE: '/inventory/receive',
    ADJUST: '/inventory/adjust',
    NEW_TRANSFER: '/inventory/transfers/new',
    TRANSFER_DETAIL: (transferId: string) => `/inventory/transfers/${transferId}`,
  },
  SALES: {
    ROOT: '/sales',
    NEW_INVOICE: '/sales/invoices/new',
    INVOICE_DETAIL: (invoiceId: string) => `/sales/invoices/${invoiceId}`,
    QUOTES: '/sales/quotes',
    ORDERS: '/sales/orders',
    RETURNS: '/sales/returns',
    CREDIT_NOTES: '/sales/credit-notes',
    NEW_CREDIT_NOTE: '/sales/credit-notes/new',
    CREDIT_NOTE_DETAIL: (creditNoteId: string) => `/sales/credit-notes/${creditNoteId}`,
    NEW_STATEMENT: '/sales/statements/new',
    NEW_PAYMENT: '/sales/payments/new',
    POS: '/sales/pos',
    POS_SHIFT_REVIEWS: '/sales/pos/shift-reviews',
  },
  PURCHASES: {
    ROOT: '/purchases',
    DOCUMENTS: '/purchases/documents',
    SUPPLIERS: '/purchases/suppliers',
    NEW_SUPPLIER: '/purchases/suppliers/new',
    SUPPLIER_DETAIL: (supplierId: string) => `/purchases/suppliers/${supplierId}`,
    SUPPLIER_EDIT: (supplierId: string) => `/purchases/suppliers/${supplierId}/edit`,
    DOCUMENT_DETAIL: (documentId: string) => `/purchases/documents/${documentId}`,
    NEW_PAYMENT: '/purchases/payments/new',
    PAYMENT_DETAIL: (paymentId: string) => `/purchases/payments/${paymentId}`,
    RETURNS: '/purchases/returns',
    NEW_RETURN: '/purchases/returns/new',
    RETURN_DETAIL: (returnId: string) => `/purchases/returns/${returnId}`,
    NEW_PURCHASE_ORDER: '/purchases/purchase-orders/new',
    NEW_BILL: '/purchases/bills/new',
  },
  MONEY: {
    ROOT: '/money',
    TRANSACTIONS: '/money/transactions',
    RECONCILIATION: '/money/reconciliation',
    CUSTOMER_CREDIT: '/money/customer-credit',
  },
  REPORTS: '/reports',
  TEAM: {
    ROOT: '/team',
    MEMBER_DETAIL: (memberId: string) => `/team/${memberId}`,
  },
  CUSTOMERS: {
    ROOT: '/customers',
    NEW: '/customers/new',
    CREATE: '/customers/create',
    VIEW: (id: string) => `/customers/${id}`,
  },
  SETTINGS: '/settings',
  HELP: '/help',
  HELP_ARTICLE: (articleId: string) => `/help/articles/${articleId}`,
  MENU: '/menu',
} as const;
